import { c as e, cB as t, cM as r, cE as o, cNotM as a } from "./ghl-ui.es384.js";
import { fadeInScaleUpTransition as i } from "./ghl-ui.es1316.js";
const l = e([t("date-picker", `
 position: relative;
 z-index: auto;
 `, [t("date-picker-icon", `
 color: var(--n-icon-color-override);
 transition: color .3s var(--n-bezier);
 `), t("icon", `
 color: var(--n-icon-color-override);
 transition: color .3s var(--n-bezier);
 `), r("disabled", [t("date-picker-icon", `
 color: var(--n-icon-color-disabled-override);
 `), t("icon", `
 color: var(--n-icon-color-disabled-override);
 `)])]), t("date-panel", `
 width: fit-content;
 outline: none;
 margin: 4px 0;
 display: grid;
 grid-template-columns: 0fr;
 border-radius: var(--n-panel-border-radius);
 background-color: var(--n-panel-color);
 color: var(--n-panel-text-color);
 user-select: none;
 `, [i(), r("shadow", `
 box-shadow: var(--n-panel-box-shadow);
 `), t("date-panel-calendar", {
  padding: "var(--n-calendar-left-padding)",
  display: "grid",
  gridTemplateColumns: "1fr",
  gridArea: "left-calendar"
}, [r("end", {
  padding: "var(--n-calendar-right-padding)",
  gridArea: "right-calendar"
})]), t("date-panel-month-calendar", {
  display: "flex",
  gridArea: "left-calendar"
}, [o("picker-col", `
 min-width: var(--n-scroll-item-width);
 height: calc(var(--n-scroll-item-height) * 6);
 user-select: none;
 -webkit-user-select: none;
 `, [e("&:first-child", `
 min-width: calc(var(--n-scroll-item-width) + 4px);
 `, [o("picker-col-item", [e("&::before", "left: 4px;")])]), o("padding", `
 height: calc(var(--n-scroll-item-height) * 5)
 `)]), o("picker-col-item", `
 z-index: 0;
 cursor: pointer;
 height: var(--n-scroll-item-height);
 box-sizing: border-box;
 padding-top: 4px;
 display: flex;
 align-items: center;
 justify-content: center;
 position: relative;
 transition: 
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 background: #0000;
 color: var(--n-item-text-color);
 `, [e("&::before", `
 z-index: -1;
 content: "";
 position: absolute;
 left: 0;
 right: 4px;
 top: 4px;
 bottom: 0;
 border-radius: var(--n-scroll-item-border-radius);
 transition: 
 background-color .3s var(--n-bezier);
 `), a("disabled", [e("&:hover::before", `
 background-color: var(--n-item-color-hover);
 `), r("selected", `
 color: var(--n-item-color-active);
 `, [e("&::before", "background-color: var(--n-item-color-hover);")])]), r("disabled", `
 color: var(--n-item-text-color-disabled);
 cursor: not-allowed;
 `, [r("selected", [e("&::before", `
 background-color: var(--n-item-color-disabled);
 `)])])])]), r("date", {
  gridTemplateAreas: `
 "left-calendar"
 "footer"
 "action"
 `
}), r("week", {
  gridTemplateAreas: `
 "left-calendar"
 "footer"
 "action"
 `
}), r("daterange", {
  gridTemplateAreas: `
 "left-calendar divider right-calendar"
 "footer footer footer"
 "action action action"
 `
}), r("datetime", {
  gridTemplateAreas: `
 "header"
 "left-calendar"
 "footer"
 "action"
 `
}), r("datetimerange", {
  gridTemplateAreas: `
 "header header header"
 "left-calendar divider right-calendar"
 "footer footer footer"
 "action action action"
 `
}), r("month", {
  gridTemplateAreas: `
 "left-calendar"
 "footer"
 "action"
 `
}), t("date-panel-footer", {
  gridArea: "footer"
}), t("date-panel-actions", {
  gridArea: "action"
}), t("date-panel-header", {
  gridArea: "header"
}), t("date-panel-header", `
 box-sizing: border-box;
 width: 100%;
 align-items: center;
 padding: var(--n-panel-header-padding);
 display: flex;
 justify-content: space-between;
 border-bottom: 1px solid var(--n-panel-header-divider-color);
 `, [e(">", [e("*:not(:last-child)", {
  marginRight: "10px"
}), e("*", {
  flex: 1,
  width: 0
}), t("time-picker", {
  zIndex: 1
})])]), t("date-panel-month", `
 box-sizing: border-box;
 display: grid;
 grid-template-columns: var(--n-calendar-title-grid-template-columns);
 align-items: center;
 justify-items: center;
 padding: var(--n-calendar-title-padding);
 height: var(--n-calendar-title-height);
 `, [o("prev, next, fast-prev, fast-next", `
 line-height: 0;
 cursor: pointer;
 width: var(--n-arrow-size);
 height: var(--n-arrow-size);
 color: var(--n-arrow-color);
 `), o("month-year", `
 user-select: none;
 -webkit-user-select: none;
 flex-grow: 1;
 position: relative;
 `, [o("text", `
 font-size: var(--n-calendar-title-font-size);
 line-height: var(--n-calendar-title-font-size);
 font-weight: var(--n-calendar-title-font-weight);
 padding: 6px 8px;
 text-align: center;
 color: var(--n-calendar-title-text-color);
 cursor: pointer;
 transition: background-color .3s var(--n-bezier);
 border-radius: var(--n-panel-border-radius);
 `, [r("active", `
 background-color: var(--n-calendar-title-color-hover);
 `), e("&:hover", `
 background-color: var(--n-calendar-title-color-hover);
 `)])])]), t("date-panel-weekdays", `
 display: grid;
 margin: auto;
 grid-template-columns: repeat(7, var(--n-item-cell-width));
 grid-template-rows: repeat(1, var(--n-item-cell-height));
 align-items: center;
 justify-items: center;
 margin-bottom: 4px;
 border-bottom: 1px solid var(--n-calendar-days-divider-color);
 `, [o("day", `
 user-select: none;
 -webkit-user-select: none;
 line-height: 15px;
 width: var(--n-item-size);
 text-align: center;
 font-size: var(--n-calendar-days-font-size);
 color: var(--n-item-text-color);
 `)]), t("date-panel-dates", `
 margin: auto;
 display: grid;
 grid-template-columns: repeat(7, var(--n-item-cell-width));
 grid-template-rows: repeat(6, var(--n-item-cell-height));
 align-items: center;
 justify-items: center;
 flex-wrap: wrap;
 `, [t("date-panel-date", `
 user-select: none;
 -webkit-user-select: none;
 position: relative;
 width: var(--n-item-size);
 height: var(--n-item-size);
 line-height: var(--n-item-size);
 text-align: center;
 font-size: var(--n-item-font-size);
 border-radius: var(--n-item-border-radius);
 z-index: 0;
 cursor: pointer;
 transition:
 background-color .2s var(--n-bezier),
 color .2s var(--n-bezier);
 `, [o("trigger", `
 position: absolute;
 left: calc(var(--n-item-size) / 2 - var(--n-item-cell-width) / 2);
 top: calc(var(--n-item-size) / 2 - var(--n-item-cell-height) / 2);
 width: var(--n-item-cell-width);
 height: var(--n-item-cell-height);
 `), r("current", [o("sup", `
 position: absolute;
 top: 2px;
 right: 2px;
 content: "";
 height: 4px;
 width: 4px;
 border-radius: 2px;
 background-color: var(--n-item-color-active);
 transition:
 background-color .2s var(--n-bezier);
 `)]), e("&::after", `
 content: "";
 z-index: -1;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 border-radius: inherit;
 transition: background-color .3s var(--n-bezier);
 `), r("covered, start, end", [a("excluded", [e("&::before", `
 content: "";
 z-index: -2;
 position: absolute;
 left: calc((var(--n-item-size) - var(--n-item-cell-width)) / 2);
 right: calc((var(--n-item-size) - var(--n-item-cell-width)) / 2);
 top: 0;
 bottom: 0;
 background-color: var(--n-item-color-included);
 `), e("&:nth-child(7n + 1)::before", {
  borderTopLeftRadius: "var(--n-item-border-radius)",
  borderBottomLeftRadius: "var(--n-item-border-radius)"
}), e("&:nth-child(7n + 7)::before", {
  borderTopRightRadius: "var(--n-item-border-radius)",
  borderBottomRightRadius: "var(--n-item-border-radius)"
})])]), r("selected", {
  color: "var(--n-item-text-color-active)"
}, [e("&::after", {
  backgroundColor: "var(--n-item-color-active)"
}), r("start", [e("&::before", {
  left: "50%"
})]), r("end", [e("&::before", {
  right: "50%"
})]), o("sup", {
  backgroundColor: "var(--n-panel-color)"
})]), r("excluded", {
  color: "var(--n-item-text-color-disabled)"
}, [r("selected", [e("&::after", {
  backgroundColor: "var(--n-item-color-disabled)"
})])]), r("disabled", {
  cursor: "not-allowed",
  color: "var(--n-item-text-color-disabled)"
}, [r("covered", [e("&::before", {
  backgroundColor: "var(--n-item-color-disabled)"
})]), r("selected", [e("&::before", {
  backgroundColor: "var(--n-item-color-disabled)"
}), e("&::after", {
  backgroundColor: "var(--n-item-color-disabled)"
})])]), r("week-hovered", [e("&::before", `
 background-color: var(--n-item-color-included);
 `), e("&:nth-child(7n + 1)::before", `
 border-top-left-radius: var(--n-item-border-radius);
 border-bottom-left-radius: var(--n-item-border-radius);
 `), e("&:nth-child(7n + 7)::before", `
 border-top-right-radius: var(--n-item-border-radius);
 border-bottom-right-radius: var(--n-item-border-radius);
 `)]), r("week-selected", `
 color: var(--n-item-text-color-active)
 `, [e("&::before", `
 background-color: var(--n-item-color-active);
 `), e("&:nth-child(7n + 1)::before", `
 border-top-left-radius: var(--n-item-border-radius);
 border-bottom-left-radius: var(--n-item-border-radius);
 `), e("&:nth-child(7n + 7)::before", `
 border-top-right-radius: var(--n-item-border-radius);
 border-bottom-right-radius: var(--n-item-border-radius);
 `)])])]), a("week", [t("date-panel-dates", [t("date-panel-date", [a("disabled", [a("selected", [e("&:hover", `
 background-color: var(--n-item-color-hover);
 `)])])])])]), r("week", [t("date-panel-dates", [t("date-panel-date", [e("&::before", `
 content: "";
 z-index: -2;
 position: absolute;
 left: calc((var(--n-item-size) - var(--n-item-cell-width)) / 2);
 right: calc((var(--n-item-size) - var(--n-item-cell-width)) / 2);
 top: 0;
 bottom: 0;
 transition: background-color .3s var(--n-bezier);
 `)])])]), o("vertical-divider", `
 grid-area: divider;
 height: 100%;
 width: 1px;
 background-color: var(--n-calendar-divider-color);
 `), t("date-panel-footer", `
 border-top: 1px solid var(--n-panel-action-divider-color);
 padding: var(--n-panel-extra-footer-padding);
 `), t("date-panel-actions", `
 flex: 1;
 padding: var(--n-panel-action-padding);
 display: flex;
 align-items: center;
 justify-content: space-between;
 border-top: 1px solid var(--n-panel-action-divider-color);
 `, [o("prefix, suffix", `
 display: flex;
 margin-bottom: -8px;
 `), o("suffix", `
 align-self: flex-end;
 `), o("prefix", `
 flex-wrap: wrap;
 `), t("button", `
 margin-bottom: 8px;
 `, [e("&:not(:last-child)", `
 margin-right: 8px;
 `)])])]), e("[data-n-date].transition-disabled", {
  transition: "none !important"
}, [e("&::before, &::after", {
  transition: "none !important"
})])]);
export {
  l as default
};
